import React from "react";
import { motion } from "framer-motion";

export default function Footer() {
  const socialLinks = [
    { 
      name: "Facebook", 
      icon: "icon-facebook", 
      url: "https://facebook.com/kayungacommunityclub",
      color: "bg-blue-600 hover:bg-blue-700"
    },
    { 
      name: "Twitter", 
      icon: "icon-twitter", 
      url: "https://twitter.com/ClubKayunga?s=09",
      color: "bg-sky-500 hover:bg-sky-600"
    },
    { 
      name: "Instagram", 
      icon: "icon-instagram", 
      url: "https://www.instagram.com/kayungacommunityclub",
      color: "bg-gradient-to-r from-purple-600 via-pink-600 to-red-500 hover:opacity-90"
    }
  ];

  const footerLinks = [
    {
      title: "Quick Links",
      links: [
        { name: "Home", url: "/" },
        { name: "Our Work", url: "/community-hiv" },
        { name: "About Us", url: "/about" },
        { name: "Contact", url: "/contact-us" }
      ]
    },
    {
      title: "Support",
      links: [
        { name: "Donate", url: "/fund-our-work" },
        // { name: "Volunteer", url: "/volunteer" },
        // { name: "Partnership", url: "/partners" },
        // { name: "Privacy Policy", url: "/privacy" }

      ]
    }
  ];

  return (
    <footer className="bg-gray-900 text-white pt-12 pb-6">
      <div className="w-full overflow-hidden transform rotate-180"><svg viewBox="0 0 1200 60" className="w-full h-8"><path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" className="fill-current text-gray-800"></path></svg></div>
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <motion.div initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }} className="space-y-3">
            <h3 className="text-lg font-semibold text-pink-400">Our Mission</h3>
            <p className="text-gray-300 text-sm">Creating A Community Free From Adversity</p>
            <div className="space-y-1 text-sm">
              <div className="flex items-center text-gray-400 hover:text-white"><span className="icon-envelope-open-o mr-2 text-xs"></span><a href="mailto:kayungacommunityclub@gmail.com">kayungacommunityclub@gmail.com</a></div>
              <div className="flex items-center text-gray-400 hover:text-white"><span className="icon-phone mr-2 text-xs"></span><a href="tel:+256200917803">+256 200 917 803</a></div>
              <div className="flex items-start text-gray-400"><span className="icon-map-marker mr-2 text-xs mt-0.5"></span><span>Sekajja road, Kayunga, Uganda</span></div>
            </div>
          </motion.div>
          {footerLinks.map((section, index) => (<motion.div key={index} initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: index * 0.1 }} className="space-y-3"><h3 className="text-lg font-semibold text-pink-400">{section.title}</h3><ul className="space-y-2">{section.links.map((link, linkIndex) => (<motion.li key={linkIndex} whileHover={{ x: 3 }} transition={{ type: "spring", stiffness: 400 }}><a href={link.url} className="text-gray-400 hover:text-white text-sm flex items-center"><span className="icon-chevron-right text-xs mr-1 opacity-70"></span>{link.name}</a></motion.li>))}</ul></motion.div>))}
          <motion.div initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.3, delay: 0.2 }} className="space-y-3">
            <h3 className="text-lg font-semibold text-pink-400">Connect With Us</h3>
            <p className="text-gray-300 text-sm">Follow our journey and stay updated</p>
            <div className="flex gap-2">{socialLinks.map((social, index) => (<motion.a key={index} href={social.url} target="_blank" rel="noopener noreferrer" className={`${social.color} w-8 h-8 rounded-full flex items-center justify-center text-white text-sm`} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}><span className={social.icon}></span></motion.a>))}</div>
            <motion.div whileHover={{ scale: 1.02 }} className="mt-4"><a href="/fund-our-work" className="inline-flex items-center justify-center px-4 py-2 rounded-full text-sm font-medium text-white bg-gradient-to-r from-orange-500 to-pink-600"><span className="icon-heart mr-1 text-xs"></span>Support Our Cause</a></motion.div>
          </motion.div>
        </div>
        <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.3 }} className="border-t border-gray-800 mt-8 pt-6 text-center text-gray-500 text-xs">
          <div className="flex flex-col md:flex-row justify-center items-center space-y-1 md:space-y-0 md:space-x-4">
            <p>© {new Date().getFullYear()} Kayunga Community Club</p><span className="hidden md:inline">•</span><p>All rights reserved</p><span className="hidden md:inline">•</span><a href="https://aspenuganda.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300">Design by Aspen Technologies</a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
}